import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'coa-account-list',
        label: 'Accounting',
        to: '/clearing/finance/accounting/account',
      }),
    }) satisfies AggregateBreadcrumb,
});
